import React from 'react'

import { useTranslation } from 'react-i18next'

import { Badge } from '@/shared/components/atoms/Badge/Badge'
import Tooltip from '@/shared/components/atoms/Tooltip'
import { useCurrentAccount } from '@/shared/hooks/useCurrentAccount'

interface ZoneStatusProps {
	className?: string
}

const ZoneStatus: React.FC<ZoneStatusProps> = ({ className }) => {
	const { t } = useTranslation('common')

	const currentAccount = useCurrentAccount()

	const availableZones = currentAccount?.availablePlayers || 0
	const activeZones = currentAccount?.playersCount || 0

	// Calculate pending zones (available zones that haven't been activated yet)
	const pendingZones = Math.max(0, availableZones - activeZones)

	return (
		<div className={`flex items-center gap-3 ${className}`}>
			<Tooltip
				title={t('top_bar.active_zones_tooltip')}
				side="bottom"
				align="center"
				className="max-w-sm whitespace-normal break-words text-left"
			>
				<div className="cursor-pointer">
					<Badge
						variant="secondary"
						className="border-0 rounded-lg px-3 py-1.5 text-sm font-medium bg-surface-light text-primary-foreground"
					>
						{activeZones} {t('top_bar.active_zones')}
					</Badge>
				</div>
			</Tooltip>

			<Tooltip
				title={t('top_bar.zones_available_for_activation_tooltip')}
				side="bottom"
				align="center"
				className="max-w-sm whitespace-normal break-words text-left"
			>
				<div className="cursor-pointer">
					<Badge
						variant="secondary"
						className="border-0 rounded-lg px-3 py-1.5 text-sm font-medium bg-black/5 dark:bg-white/5 text-foreground gap-2"
					>
						{pendingZones} {t('top_bar.zones_pending_activation')}
					</Badge>
				</div>
			</Tooltip>
		</div>
	)
}

export default ZoneStatus
